export default class Timer {

    constructor() {
    }

    init() {
        $('[data-timer-fast]').off('click').on('click', this.timerFastClick);
    }

    timerFastClick(e) {
        e.preventDefault();
        let value = $(e.currentTarget).data('timer-fast');
        let $content = $(e.currentTarget).closest('[data-js-timer]');
        let $day = $content.find('[name="timer[days][]"]');
        let $hour = $content.find('[name="timer[hours][]"]');

        let days = [];
        $day.find('option').each(function(i, el) {
            days.push($(el).prop('value'));
        });

        let hours = [];
        $hour.find('option').each(function(i, el) {
            hours.push($(el).prop('value'));
        });

        let dayValue = [];
        let hourValue = [];
        switch (value) {
            case 'one-week':
                dayValue.push(getRandom(days));
                hourValue.push(getRandom(hours));
                break;
            case 'one-day':
                dayValue = days;
                hourValue.push(getRandom(hours));
                break;
            case 'three-hour':
                dayValue = days;
                for (let i = 0; i < 24; i = i+3) {
                    hourValue.push(hours[i]);
                }
                break;
            case 'two-day':
                dayValue = days;
                hourValue.push(getRandom(hours.slice(1, 10)));
                hourValue.push(getRandom(hours.slice(-10)));
                break;
            case 'one-hour':
                dayValue = days;
                hourValue = hours;
                break;
        }

        $day.val(dayValue).chosen().trigger('chosen:updated');
        $hour.val(hourValue).chosen().trigger('chosen:updated');
    }
}
